import { MERGE_TAGS } from "utilities/enums"

export type Segment = { type: "text"; value: string } | { type: "tag"; value: string }

const TAG_REGEX = /\{\{([^}]+)\}\}/g

export const parseSegments = (text: string): Segment[] => {
  const segments: Segment[] = []
  const regex = new RegExp(TAG_REGEX.source, TAG_REGEX.flags)
  let lastIndex = 0
  let match = regex.exec(text)

  while (match !== null) {
    if (match.index > lastIndex) {
      segments.push({ type: "text", value: text.slice(lastIndex, match.index) })
    }
    segments.push({ type: "tag", value: match[1] })
    lastIndex = match.index + match[0].length
    match = regex.exec(text)
  }

  if (lastIndex < text.length) {
    segments.push({ type: "text", value: text.slice(lastIndex) })
  }

  return segments
}

export const findLabel = (
  id: string,
  forms: { externalId: string; name: string }[],
): string => {
  const mergeTag = MERGE_TAGS.find((t) => t.id === id)
  if (mergeTag) return mergeTag.label

  if (id.startsWith("FORM_")) {
    const formId = id.replace("FORM_", "")
    const form = forms.find((f) => f.externalId === formId)

    return form ? form.name : "Form Link"
  }

  return id
}
